export default __webpack_public_path__ + "images/J4.96e08c2.png";